<template>
  <div class="bd-1-solid-grey min-h-2 bgc-grey my-2 clearfix">
    <div v-if="isEdit" class="d-flex align-items-center justify-content-between pa-2">
      <a-input v-model="title" class="w-4" />
      <a @click="confirm">{{ 'ok' | i18n }}</a>
    </div>
    <div v-else class="d-flex align-items-center justify-content-between pa-2">
      <span class="fs-16">
        <ellipsis tooltip :length="12">{{ argGroup.title }}</ellipsis>
      </span>
      <span>
        <a @click="edit">
          <a-icon type="edit" />
        </a>
        <a-divider type="vertical" />
        <a @click="remove">
          <a-icon type="close" />
        </a>
      </span>
    </div>
    <draggable v-model="argGroup.group" v-bind="dragOptions" class="pa-2 min-h-1">
      <ArgTag
        v-for="arg in argGroup.group"
        :key="arg.id"
        :arg="arg"
        @change="show => arg.show = show"
      />
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import ArgTag from './ArgTag'
export default {
  components: {
    draggable,
    ArgTag,
  },
  props: {
    argGroup: {
      type: Object,
      default: () => ({ title: '', group: [] }),
    },
  },
  data() {
    return {
      title: '',
      isEdit: false,
      dragOptions: {
        animation: 0,
        group: 'args',
        ghostClass: 'ghost',
      },
    }
  },
  methods: {
    confirm() {
      if (!this.title) {
        this.$message.info(this.$i18n.t('page_mdc_realtime_group_name'))
        return
      }
      this.$emit('change', this.title)
      this.isEdit = false
    },
    edit() {
      this.title = this.argGroup.title
      this.isEdit = true
    },
    remove() {
      this.$emit('del')
      this.isEdit = false
    },
  },
}
</script>

<style scoped>
.clearfix::after {
  display: block;
  clear: both;
  content: '';
}
</style>

